import React from 'react';

import { node } from 'prop-types';
import { HTML5toTouch } from 'rdndmb-html5-to-touch';
import { DndProvider } from 'react-dnd-multi-backend';

const DragDropProvider = ({ children }) => (
  <DndProvider options={HTML5toTouch}>{children}</DndProvider>
);

DragDropProvider.propTypes = {
  children: node.isRequired,
};

export default DragDropProvider;
